const HOST = process.env.REACT_APP_API_URL;
const VERSION = process.env.REACT_APP_API_VERSION;

const APP_URL_NOTES = {
  // LISTAR NOTAS
  LIST_NOTES: `${HOST}${VERSION}admin/dashboard/notas/listar`,
  LIST_DEFINITIVAS_CURSO: `${HOST}${VERSION}admin/dashboard/notas/listarDefinitivasCurso`,
  // CREAR NOTES
  CREATE_NOTES: `${HOST}${VERSION}admin/dashboard/notas/crear`,
  // DESCARGAR FORMATO
  DOWNLOAD_FORM: `${HOST}${VERSION}admin/dashboard/notas/descargarPlanilla`,
  // CARGAR FORMATO
  UPLOAD_FORM: `${HOST}${VERSION}admin/dashboard/notas/cargarPlanilla`,

  // LISTAR OBSERVACIONES
  LIST_OBSERVATIONS: `${HOST}${VERSION}admin/dashboard/notas/listarObservaciones`,
  // CREAR OBSERVACIONES
  CREATE_OBSERVATIONS: `${HOST}${VERSION}admin/dashboard/notas/crearObservaciones`,

  // LISTAR RECUPERACIONES
  LIST_RECUPERATIONS: `${HOST}${VERSION}admin/dashboard/notas/listarNotasRecuperaciones`,
  // CREAR RECUPERACIONES
  CREATE_RECUPERATIONS: `${HOST}${VERSION}admin/dashboard/notas/crearNotasRecuperaciones`,

  // CREAR OBSERVACIONES RECUPERACION 
  CREATE_OBSERVATIONS_RECOVERY: `${HOST}${VERSION}admin/dashboard/notas/crearObservacionesRecuperacion`,

  // LISTAR OBSERVACIONES RECUPERACIÓN
  LIST_OBSERVATIONS_RECOVERY: `${HOST}${VERSION}admin/dashboard/notas/listarObservacionesRecuperaciones`,
  // CREAR OBSERVACIONES RECUPERACIÓN
  HISTORY_NOTES: `${HOST}${VERSION}admin/dashboard/auditoria/listarNotasMatricula`,
  //PROMEDIO TOTAL
  PROMEDIO_TOTAL: `${HOST}${VERSION}admin/dashboard/notas/promedios/total`,
  PROMEDIO_TOTAL_TEACHER: `${HOST}${VERSION}admin/dashboard/notas/promedios/totalTeacher`,
  GRADO_PROMEDIO_EXTREMO: `${HOST}${VERSION}admin/dashboard/notas/promedios/extremos`,
  GRADO_PROMEDIO_EXTREMO_TEACHER: `${HOST}${VERSION}admin/dashboard/notas/promedios/extremosTeacher`,
  PROMEDIO_POR_GRADO: `${HOST}${VERSION}admin/dashboard/notas/promedios/por-grado`,
  PROMEDIO_POR_PERIODO: `${HOST}${VERSION}admin/dashboard/notas/promedios/por-periodo`,
  CLASES_HOY: `${HOST}${VERSION}admin/dashboard/notas/promedios/clases-hoy`,
  ACTIVIDADES_PROXIMAS: `${HOST}${VERSION}admin/dashboard/notas/promedios/actividades-proximas`,
  DISTRIBUCION_PROMEDIOS: `${HOST}${VERSION}admin/dashboard/notas/promedios/distribucion`,
  RESUMEN_EVALUACION_DOCENTE: `${HOST}${VERSION}admin/dashboard/notas/evaluacion/resumen-docente`,
  RESUMEN_EVALUACION: `${HOST}${VERSION}admin/dashboard/notas/evaluacion/resumen`,
  RESUMEN_ACADEMICO: `${HOST}${VERSION}admin/dashboard/notas/promedios/resumen`,
  //TOP AREAS
  AREAS_PROMEDIO_EXTREMO: `${HOST}${VERSION}admin/dashboard/notas/promedios/top-areas`,
  AREAS_PROMEDIO_EXTREMO_TEACHER: `${HOST}${VERSION}admin/dashboard/notas/promedios/top-areas-docente`,
  //PROMEDIO X GENERO
  PROMEDIO_GENEROS: `${HOST}${VERSION}admin/dashboard/notas/promedios/por-genero`,
  PROMEDIO_GENEROS_DOCENTE: `${HOST}${VERSION}admin/dashboard/notas/promedios/por-genero-docente`,
  //TOP 3 ESTUDIANTES > PROMEDIO
  TOP_ESTUDIANTES: `${HOST}${VERSION}admin/dashboard/notas/promedios/top-estudiantes`,
  TOP_ESTUDIANTES_DOCENTE: `${HOST}${VERSION}admin/dashboard/notas/promedios/top-estudiantes-docente`,
  // TOP 3 DOCENTES > PROMEDIO
  TOP_DOCENTES: `${HOST}${VERSION}admin/dashboard/notas/promedios/top-docentes`,
  // TOP 10 ESTUDIANTES CON ASIGNATURAS PERDIDAS
  TOP_ESTUDIANTES_PERDIDAS: `${HOST}${VERSION}admin/dashboard/notas/promedios/top-estudiantes-perdidas`,
  TOP_ESTUDIANTES_PERDIDAS_DOCENTE: `${HOST}${VERSION}admin/dashboard/notas/promedios/top-estudiantes-perdidas-docente`,
  // TOP PROMEDIOS POR DIAS
  TOP_PROMEDIOS_POR_DIAS: `${HOST}${VERSION}admin/dashboard/notas/promedios/por-dias`,
  TOP_PROMEDIOS_POR_DIAS_DOCENTE: `${HOST}${VERSION}admin/dashboard/notas/promedios/por-dias-docente`,
  // CERTIFICADOS DE NOTAS GRL
  CERTIFICADO_NOTAS_GRL: `${HOST}${VERSION}admin/dashboard/notas/certificados/notas-grl`,
  // Configuración de URL en el frontend
  LISTAR_ESTUDIANTES_GRADOGRUPO: `${HOST}${VERSION}admin/dashboard/notas/estudiantes/listar-estudiantes`,
  // CERTIFICADOS DE NOTAS VDP
  CERTIFICADO_NOTAS_VDP: `${HOST}${VERSION}admin/dashboard/notas/certificados/notas-vdp`,
  // CERTIFICADOS DE BUENA CONDUCTA
  CERTIFICADO_NOTAS_BUECOND: `${HOST}${VERSION}admin/dashboard/notas/certificados/notas-buecond`,
  // LISTAR NOTAS ACTIVIDAD CENTRO ACADEMICO
  LIST_NOTES_ACTIVITY_CENTRO_ACADEMICO: `${HOST}${VERSION}admin/dashboard/notas/listarNotasActividadCentroAcademico`,
  // LISTAR NOTAS ACTIVIDAD FORO CENTRO ACADEMICO
  LIST_NOTES_ACTFORO_CENTRO_ACADEMICO: `${HOST}${VERSION}admin/dashboard/notas/listarNotasActForoCentroAcademico`,
  // LISTAR ACTIVIDADES Y FOROS CENTRO ACADEMICO MI AGENDA
  LIST_ACTSFOROS_CENTRO_ACADEMICO: `${HOST}${VERSION}admin/dashboard/notas/listarActividadesYForosParaEstudiante`,
  // PLANILLA MENSUAL NOTAS
  PLANILLA_MENSUAL_NOTAS: `${HOST}${VERSION}admin/dashboard/notas/planilla-mensual-notas`,
  // PLANILLA MENSSUAL NOTA MASISVO
  PLANILLA_MENSUAL_NOTAS_MASIVAS: `${HOST}${VERSION}admin/dashboard/notas/planilla-mensual-notas-masiva`,
  PLANILLA_MENSUAL_NOTAS_MASIVAS_TOTAL: `${HOST}${VERSION}admin/dashboard/notas/planilla-mensual-notas-masiva-total`,
  OPCIONES_PLANILLA_MENSUAL_MASIVA: `${HOST}${VERSION}admin/dashboard/notas/opciones-planilla-mensual-masiva`,
  GET_PLANILLA_NOTAS_JOB: `${HOST}${VERSION}admin/dashboard/notas/planilla-mensual-notas-masiva-total/job/`,
  HISTORIAL_PLANILLA_NOTAS_MASIVA: `${HOST}${VERSION}admin/dashboard/notas/planilla-mensual-notas-masiva-total/historial`,
  DESCARGAR_HISTORIAL_PLANILLA_NOTAS_MASIVA: `${HOST}${VERSION}admin/dashboard/notas/planilla-mensual-notas-masiva-total/historial/descargar`,
  ELIMINAR_HISTORIAL_PLANILLA_NOTAS_MASIVA: `${HOST}${VERSION}admin/dashboard/notas/planilla-mensual-notas-masiva-total/historial/eliminar`,
  //OBTENTER PROMEDIO DE NOTAS GENERAL DE ESTUDIANTES
  OBTENER_PROMEDIOS_GENERAL_ESTUDIANTE: `${HOST}${VERSION}admin/dashboard/notas/promedios/mejor-estudiante-grupo`,
  //OBTENTER PROMEDIO DE NOTAS GRADOGRUPO_PERIODO
  OBTENER_PROMEDIOS_GRADOGRUPO_PERIODO: `${HOST}${VERSION}admin/dashboard/reportes/listarPromediosPorGradoGrupoPeriodo`,
  //OBTENTER PROMEDIO DE NOTAS GRADOGRUPO_PERIODO
  OBTENER_OBSERVACIONES_GRADOGRUPO_PERIODO: `${HOST}${VERSION}admin/dashboard/escalavalorativa/listarObservacionesPorGradoGrupoYPeriodo`,
  // CONVIVENCIA GENERAL DOCENTE
  GUARDAR_CONVIVENCIA_DOCENTE: `${HOST}${VERSION}admin/dashboard/notas/guardarConvivenciaDocente`,
  LISTAR_CONVIVENCIA_DOCENTE: `${HOST}${VERSION}admin/dashboard/notas/listarConvivenciaDocente`,
  GUARDAR_CONVIVENCIA_DOCENTE_DETALLE: `${HOST}${VERSION}admin/dashboard/notas/guardarConvivenciaDocenteDetalle`,
  LISTAR_CONVIVENCIA_DOCENTE_DETALLE: `${HOST}${VERSION}admin/dashboard/notas/listarConvivenciaDocenteDetalle`,
  // MODO DE CÁLCULO PARA COMPETENCIAS SIN ACTIVIDADES/NOTAS
  GET_MODO_COMPETENCIAS_VACIAS: `${HOST}${VERSION}admin/dashboard/reportes/configuracion/modo-competencias-vacias`,
  SAVE_MODO_COMPETENCIAS_VACIAS: `${HOST}${VERSION}admin/dashboard/reportes/configuracion/modo-competencias-vacias/guardar`,
  // MODO DE CÁLCULO: NOTA EN 0 CUENTA COMO VACÍA
  GET_CONTAR_CERO_COMO_VACIA: `${HOST}${VERSION}admin/dashboard/reportes/configuracion/contar-cero-como-vacia`,
  SAVE_CONTAR_CERO_COMO_VACIA: `${HOST}${VERSION}admin/dashboard/reportes/configuracion/contar-cero-como-vacia/guardar`,
};
export default APP_URL_NOTES;
